module.exports = __webpack_public_path__ + "onboarding6.png";